import React, { useState, useEffect } from 'react';
import * as Scrivito from 'scrivito';

// Also read by the inline <script id="tt-cookie-state"> in index.html (copied
// into every prerendered page by api/prerender.mjs) - keep them in sync.
const COOKIE_KEY = 'tt_cookies_accepted';

function findHomepage(page) {
  if (!page) return null;
  if (page.objClass() === 'Homepage') return page;
  const parent = page.parent();
  if (!parent) return null;
  return findHomepage(parent);
}

// Rendered by default - server and client alike - and removed once the
// client sees consent was already given. Previously it only mounted after
// hydration, so on prerendered pages the banner (the largest element in the
// viewport on most of them) became the Largest Contentful Paint only after
// the whole JS bundle had loaded (Lighthouse mobile: LCP 3-3.8s vs ~1.5s).
// Returning visitors never see it flash: index.html's tt-cookie-state script
// tags <html> with .tt-cookies-accepted before first paint, which main.scss
// uses to hide it until this effect removes it. Starting hidden instead would
// make the client's first render differ from the prerendered markup
// (a hydration mismatch).
const CookieNotice = Scrivito.connect(({ page }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (localStorage.getItem(COOKIE_KEY)) setVisible(false);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, '1');
    setVisible(false);
    fetch('/api/accepted_cookies_hint');
  };

  if (!visible) return null;

  const hp = findHomepage(page);
  if (!hp) return null;

  const link = hp.get('cookieNoticeLink');

  // Flat and centred, as in the Rails partial: the notice text in an <i>, then
  // the optional link, then the accept button, all on one line. Wrapping it in a
  // .container with flexbox left-aligned the button and shrank the text.
  //
  // The explicit spaces matter: the HAML template put each element on its own
  // line, so the browser had a break opportunity between them and wrapped right
  // after the notice text. Without them the last word of the text is dragged
  // onto the button's line, which shifts the button 39px to the right.
  return (
    <div className="cookie-notice">
      <Scrivito.ContentTag tag="i" attribute="cookieNotice" content={hp} />{' '}
      {link && (
        <a href={Scrivito.urlFor(link)} className="cookie-link">
          {link.title() || ''}
        </a>
      )}{' '}
      <button
        type="button"
        id="acceptedCookies"
        className="btn btn-default green-button"
        onClick={accept}
      >
        <Scrivito.ContentTag tag="span" attribute="cookieNoticeButtonText" content={hp} />
      </button>
    </div>
  );
});

export default CookieNotice;
